export const HOSTS = {
    pension: 'https://www.raisin-pension.de',
    invest: 'https://invest.raisin.com',
    staging: (name, type) => type === 'invest'
        ? `https://obs-api-${name}.fairr.online/.invest`
        : `https://obs-api-${name}.fairr.online`,
};
export const getPensionHost = (type = 'pension') => {
    var _a, _b, _c;
    if (typeof global !== 'undefined' &&
        ((_c = (_b = (_a = global === null || global === void 0 ? void 0 : global.window) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.host) === null || _c === void 0 ? void 0 : _c.indexOf('raisin-dev.network')) >= 0) {
        const name = /bk-deu-(.*)\.raisin-dev\.network/.exec(global.window.location.host);
        return name ? HOSTS.staging(name[1], type) : HOSTS[type];
    }
    return HOSTS[type];
};
export const hasEtfConfiguratorProducts = (pensionProducts) => { var _a, _b; return !!((_b = (_a = pensionProducts === null || pensionProducts === void 0 ? void 0 : pensionProducts.products) === null || _a === void 0 ? void 0 : _a.filter((p) => p.type === 'invest')) === null || _b === void 0 ? void 0 : _b.length); };
export const hasPPProducts = (pensionProducts) => { var _a, _b; return !!((_b = (_a = pensionProducts === null || pensionProducts === void 0 ? void 0 : pensionProducts.products) === null || _a === void 0 ? void 0 : _a.filter((p) => p.type === 'fairr')) === null || _b === void 0 ? void 0 : _b.length); };
//# sourceMappingURL=pensionProducts.js.map